/**
 * assets/product-section.js
 * Gedrag van sections/product.liquid
 *
 * Geknipt uit het {% javascript %}-blok van die section op 16-08-2026, 1:1.
 * Shopify plakte die blokken tot één compiled_assets/scripts.js dat op elke
 * pagina laadde, ook waar de section niet voorkwam. Nu laadt alleen deze
 * section zijn eigen gedrag. Zie ARCHITECTURE.md sectie 11.
 */

/*
 * Eenmalige uitvoering. Shopify voegde alle {% javascript %}-blokken samen tot
 * één bestand dat precies één keer draaide, ongeacht hoe vaak de section op de
 * pagina stond. Deze guard houdt dat gedrag exact gelijk nu elke section zijn
 * eigen script-tag rendert.
 */
(function () {
  'use strict';
  if (window.__vc_productSection) return;
  window.__vc_productSection = true;

  // === Scroll to Reviews Tab ===
    document.querySelectorAll('[data-scroll-to-reviews]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (isMobile) {
          // Mobile: open the reviews accordion
          const reviewsAccordion = document.querySelector('[data-accordion-reviews]');
          if (reviewsAccordion) {
            reviewsAccordion.open = true;
            setTimeout(() => {
              const headerH = document.querySelector('[data-header]')?.offsetHeight || 72;
              const y = reviewsAccordion.getBoundingClientRect().top + window.scrollY - headerH - 12;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }, 100);
          }
        } else {
          // Desktop: switch to reviews tab
          const reviewsTab = document.querySelector('[data-product-tab="reviews"]');
          const reviewsPanel = document.querySelector('[data-product-panel="reviews"]');
          if (reviewsTab) {
            reviewsTab.click();
            setTimeout(() => {
              const target = reviewsPanel || reviewsTab;
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        }
      });
    });

    // === AJAX Product Form, prevent full page reload ===
    const productForm = document.querySelector('[data-atc-btn]')?.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = productForm.querySelector('[data-atc-btn]');
        if (!btn) return;

        const formData = new FormData(productForm);
        const btnText = btn.querySelector('span');
        const originalText = btnText ? btnText.textContent : btn.textContent;
        if (btnText) btnText.textContent = 'Toevoegen…';
        else btn.textContent = 'Toevoegen…';
        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: parseInt(formData.get('id')),
              quantity: parseInt(formData.get('quantity')) || 1
            })
          });

          if (res.ok) {
            const data = await res.json();
            if (btnText) btnText.textContent = 'Toegevoegd ✓';
            else btn.textContent = 'Toegevoegd ✓';
            btn.classList.replace('bg-koi', 'bg-green-500');

            // ARIA live announcement
            const liveRegion = document.getElementById('AjaxLiveRegion');
            if (liveRegion) liveRegion.textContent = `${data.title || 'Product'} toegevoegd aan winkelwagen`;

            // Refresh cart drawer contents + open it
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (window.CartDrawer) window.CartDrawer.open();

            setTimeout(() => {
              if (btnText) btnText.textContent = originalText;
              else btn.textContent = originalText;
              btn.classList.replace('bg-green-500', 'bg-koi');
              btn.disabled = false;
            }, 2000);
          } else {
            if (btnText) btnText.textContent = 'Fout, probeer opnieuw';
            else btn.textContent = 'Fout, probeer opnieuw';
            setTimeout(() => {
              if (btnText) btnText.textContent = originalText;
              else btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          }
        } catch(err) {
          if (btnText) btnText.textContent = originalText;
          else btn.textContent = originalText;
          btn.disabled = false;
          console.error('ATC error:', err);
        }
      });
    }

    // Thumbnail gallery
    const thumbs = document.querySelectorAll('[data-thumb]');
    const slides = document.querySelectorAll('[data-slide]');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = thumb.dataset.thumb;
        slides.forEach(s => { s.classList.add('hidden'); });
        thumbs.forEach(t => { t.classList.remove('border-navy', 'opacity-100'); t.classList.add('border-transparent', 'opacity-60'); });
        const target = document.querySelector(`[data-slide="${idx}"]`);
        if (target) target.classList.remove('hidden');
        thumb.classList.remove('border-transparent', 'opacity-60');
        thumb.classList.add('border-navy', 'opacity-100');
      });
    });

    // === PDP Zoom ===
    const galleryMain = document.querySelector('[data-gallery-main]');
    if (galleryMain) {
      const zoomType = galleryMain.classList.contains('cursor-zoom-in') ? 'active' : null;
      const zoomLightbox = document.getElementById('zoom-lightbox');

      if (zoomType) {
        // Hover zoom, track mouse position for transform-origin
        galleryMain.addEventListener('mousemove', (e) => {
          const rect = galleryMain.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          const activeImg = galleryMain.querySelector('[data-slide]:not(.hidden) .pdp-zoom-wrap img');
          if (activeImg) {
            activeImg.style.transformOrigin = `${x}% ${y}%`;
          }
        });

        // Reset on mouse leave
        galleryMain.addEventListener('mouseleave', () => {
          const activeImg = galleryMain.querySelector('[data-slide]:not(.hidden) .pdp-zoom-wrap img');
          if (activeImg) {
            activeImg.style.transformOrigin = 'center center';
          }
        });

        // Click zoom, open lightbox
        if (zoomLightbox) {
          galleryMain.addEventListener('click', () => {
            const activeImg = galleryMain.querySelector('[data-slide]:not(.hidden) img');
            if (!activeImg) return;
            const lbImg = zoomLightbox.querySelector('[data-zoom-lightbox-img]');
            if (lbImg) {
              lbImg.src = activeImg.currentSrc || activeImg.src;
              lbImg.alt = activeImg.alt || '';
            }
            zoomLightbox.showModal();
          });

          // Close on inner click
          const lbInner = zoomLightbox.querySelector('[data-zoom-lightbox-inner]');
          if (lbInner) {
            lbInner.addEventListener('click', (e) => {
              if (e.target === lbInner || e.target.tagName === 'IMG') {
                zoomLightbox.close();
              }
            });
          }
        }
      }
    }

    // Quantity selector
    const qtyInput = document.querySelector('[data-qty-input]');
    const qtyMinus = document.querySelector('[data-qty-minus]');
    const qtyPlus = document.querySelector('[data-qty-plus]');

    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', () => {
        const val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', () => {
        const val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Mobile carousel dot indicators, IntersectionObserver
    const mobileGallery = document.querySelector('[data-gallery-mobile]');
    const galleryDots = document.querySelectorAll('[data-gallery-dot]');
    if (mobileGallery && galleryDots.length > 1) {
      const mediaSlides = mobileGallery.querySelectorAll('[data-media-slide]');
      const dotObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = entry.target.dataset.mediaSlide;
            galleryDots.forEach(dot => {
              const isActive = dot.dataset.galleryDot === idx;
              dot.classList.toggle('bg-navy', isActive);
              dot.classList.toggle('w-5', isActive);
              dot.classList.toggle('bg-slate-300', !isActive);
              dot.classList.toggle('w-2', !isActive);
            });
          }
        });
      }, { root: mobileGallery, threshold: 0.6 });
      mediaSlides.forEach(slide => dotObserver.observe(slide));

      // Tap dot → scroll to slide
      galleryDots.forEach(dot => {
        dot.addEventListener('click', () => {
          const slide = mobileGallery.querySelector(`[data-media-slide="${dot.dataset.galleryDot}"]`);
          if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
    }

    // Sticky Add-to-Cart, show when original button out of view
    const atcBtn = document.querySelector('[data-atc-btn]');
    const stickyAtc = document.querySelector('[data-sticky-atc]');
    if (atcBtn && stickyAtc) {
      const observer = new IntersectionObserver(([entry]) => {
        stickyAtc.classList.toggle('translate-y-full', entry.isIntersecting);
        stickyAtc.classList.toggle('translate-y-0', !entry.isIntersecting);
      }, { threshold: 0 });
      observer.observe(atcBtn);
    }

    // Sticky ATC, AJAX add-to-cart (no page reload)
    const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', async () => {
        const variantId = stickyBtn.dataset.variantId;
        const originalText = stickyBtn.textContent;
        stickyBtn.textContent = 'Toevoegen…';
        stickyBtn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          });

          if (res.ok) {
            stickyBtn.textContent = 'Toegevoegd ✓';
            // Refresh cart drawer contents + open it
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (window.CartDrawer) window.CartDrawer.open();
            setTimeout(() => {
              stickyBtn.textContent = originalText;
              stickyBtn.disabled = false;
            }, 2000);
          } else {
            stickyBtn.textContent = 'Fout, probeer opnieuw';
            setTimeout(() => {
              stickyBtn.textContent = originalText;
              stickyBtn.disabled = false;
            }, 2000);
          }
        } catch(e) {
          stickyBtn.textContent = originalText;
          stickyBtn.disabled = false;
          console.error('Sticky ATC error:', e);
        }
      });
    }
})();
